/* eslint-disable */

import isBrowser from './isBrowser';
import isDevelopment from './isDevelopment';

// Numeric Microsoft Advertising customer id (cid). Not the UET tag ID
// and not the C-prefixed customer number shown in the account switcher.
const BING_ID_SYNC_RED3 = 'BACID_115812';

function isTargetedAdvertisingDenied() {
  if (!window.dataLayer) {
    return false;
  }

  const consent = [...window.dataLayer]
    .reverse()
    .find((event) => typeof event.targeted_advertising !== 'undefined')
    ?.targeted_advertising;

  return consent === false;
}

/**
 * Fire Microsoft's client-side ID sync pixel. vid must be the same match ID
 * the conversion job sends as userData.anonymousId.
 */
export function initBingIdSync(anonymousId) {
  if (
    isDevelopment() ||
    !anonymousId ||
    !isBrowser() ||
    window.initBingIdSync ||
    isTargetedAdvertisingDenied()
  ) {
    return;
  }

  window.initBingIdSync = true;

  const img = document.createElement('img');
  img.width = 1;
  img.height = 1;
  img.alt = '';
  img.setAttribute('aria-hidden', 'true');
  img.style.display = 'none';
  img.src = `https://c.bing.com/c.gif?vid=${encodeURIComponent(
    String(anonymousId)
  )}&Red3=${BING_ID_SYNC_RED3}`;
  document.body.appendChild(img);
}

export function initGtm(gtmSiteId, { schoolCode } = {}) {
  if (!gtmSiteId) {
    return '';
  }

  // COPIED FROM GTM CONSOLE (GTM and A/B test Anti Flicker Script)
  return `


    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '${gtmSiteId}');
  `;
}

export function initJornaya(jornayaCampaignId) {
  if (!jornayaCampaignId || !isBrowser()) {
    return;
  }

  // LeadID sets window.LeadiD on load; also guard our own flag + existing tag
  // so React remounts / Strict Mode never inject a second campaign script.
  if (
    window.LeadiD ||
    window.initJornaya ||
    document.getElementById('LeadiDscript_campaign')
  ) {
    return;
  }

  window.initJornaya = true;

  var s = document.createElement('script');
  s.id = 'LeadiDscript_campaign';
  s.type = 'text/javascript';
  s.async = true;
  s.src = `//create.lidstatic.com/campaign/${jornayaCampaignId}.js?snippet_version=2`;

  // Prefer body so the script sits outside React's __next tree (avoids
  // hydration/remount side effects). Fall back to inserting before __next.
  if (document.body) {
    document.body.appendChild(s);
    return;
  }

  var nextRoot = document.getElementById('__next');
  if (nextRoot && nextRoot.parentNode) {
    nextRoot.parentNode.insertBefore(s, nextRoot);
  }
}

export function initTrustedForm() {
  try {
    if (isDevelopment()) {
      return;
    }

    (function () {
      var field = 'xxTrustedFormCertUrl';
      var provideReferrer = false;
      var invertFieldSensitivity = false;
      var tf = document.createElement('script');
      var isSandbox = isDevelopment();
      tf.type = 'text/javascript';
      tf.async = true;
      tf.src =
        'http' +
        ('https:' == document.location.protocol ? 's' : '') +
        '://api.trustedform.com/trustedform.js?provide_referrer=' +
        escape(provideReferrer) +
        '&field=' +
        escape(field) +
        '&l=' +
        new Date().getTime() +
        Math.random() +
        '&invert_field_sensitivity=' +
        invertFieldSensitivity +
        '&sandbox=' +
        isSandbox +
        '&use_tagged_consent=true';

      document.body.appendChild(tf);
    })();
  } catch (error) {
    /* silent its ok to fail as per Sung */
  }
}

export function appendGAValue(key, value) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ [key]: value });
  } catch (error) {
    // Silently Fail
  }
}
